export default "__VITE_ASSET__5pj1b$C___"